<div class="switch-btn">
	<div class="form-check form-switch">
		<input type="checkbox" class="form-check-input" [id]="'switch-'+id" [formControl]="control" [checked]="value">
		<label class="form-check-label" [for]="'switch-'+id" [ngClass]="labelClasses">
			{{ label }}
			<ng-content select="[switch-label]"></ng-content>
		</label>
	</div>
</div>